// #region Imports

// Angular
import { Component, EventEmitter, Output } from '@angular/core';

// #endregion

@Component({
  selector: 'hs-terms-and-conditions',
  templateUrl: './terms-and-conditions.component.html',
  styleUrls: ['./terms-and-conditions.component.scss']
})
export class TermsAndConditionsComponent {
  @Output() backClicked = new EventEmitter();

  onBackClicked(e: any) {
    e.preventDefault();
    this.backClicked.emit();
  }
}
